import React, { useEffect, useState } from "react";
import Project from "../../api/project";
import { Link } from "react-router-dom";
import { Pagination, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import axios from "axios";

const CaseStudySection = (props) => {
  const [caseStudy, setCaseStudy] = useState([]);
  useEffect(() => {
    const fetchCaseStudy = async () => {
      try {
        const res = await axios.get(`https://api.rashtechinfo.com/casestudy`);
        setCaseStudy(res.data.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchCaseStudy();
  }, []);
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <section className="portfolio_section xb-hidden section_space pb-5">
      <div className="container">
        <div className="heading_block">
          <div className="row align-items-end">
            <div className="col-lg-7">
              <div className="heading_focus_text">
                <span className="badge bg-secondary text-white">Journey</span>
                Success With Project
              </div>
              <h2 className="heading_text">Our Best Work Journey</h2>
              <p className="heading_description mb-0">
                Our recent projects highlight our expertise in delivering
                tailored solutions that meet the unique needs and objectives of
                our clients, custom software.
              </p>
            </div>
            <div className="col-lg-5 d-none d-lg-flex justify-content-end">
              <Link
                onClick={ClickHandler}
                to={"/case-study"}
                className="btn btn-primary"
              >
                <span className="btn_label" data-text="All Case Study">
                  All Case Study
                </span>
                <span className="btn_icon">
                  <i className="fa-solid fa-arrow-up-right"></i>
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="portfolio_carousel">
        <Swiper
          // install Swiper modules
          modules={[Pagination, A11y]}
          slidesPerView={1}
          loop={true}
          spaceBetween={30}
          allowTouchMove={true}
          centeredSlides={true}
          // pagination={{ clickable: true }}
          speed={400}
          parallax={true}
          breakpoints={{
            1025: {
              slidesPerView: 2,
            },
          }}
        >
          {caseStudy.slice(0, 5).map((project, prj) => (
            <SwiperSlide key={prj}>
              <div className="portfolio_block">
                <div className="portfolio_image">
                  <Link
                    onClick={ClickHandler}
                    className="portfolio_image_wrap bg-light"
                    to={`/case-study/${project.caseStudyTitle.replace(/\s+/g, "-")}`}
                  >
                    <img
                      src={`https://api.rashtechinfo.com/uploads/${project.bannerImage}`}
                      alt="Mobile App Design"
                      onError={(e) => {
                        const target = e.currentTarget;
                        if (target.dataset.fallbackApplied) return; // avoid loop
                        target.dataset.fallbackApplied = "1";
                        target.src =
                          "https://media.licdn.com/dms/image/v2/C5112AQEw1fXuabCTyQ/article-inline_image-shrink_1500_2232/article-inline_image-shrink_1500_2232/0/1581099611064?e=1761177600&v=beta&t=7hMw9_W0flONIBUwsc_H29TRe6QykU2h6zaf1rOHEzQ";
                      }}
                    />
                  </Link>
                </div>
                <div className="portfolio_content">
                  <h3 className="portfolio_title">
                    <Link
                      onClick={ClickHandler}
                      to={`/case-study/${project.caseStudyTitle.replace(/\s+/g, "-")}`}
                    >
                      {project.caseStudyTitle}
                    </Link>
                  </h3>
                  <ul className="category_list unordered_list">
                    <li>
                      <Link
                        onClick={ClickHandler}
                        to={`/case-study/${project.caseStudyTitle.replace(/\s+/g, "-")}`}
                      >
                        {project.clientIndustry}
                      </Link>
                    </li>
                  </ul>
                  <Link
                    onClick={ClickHandler}
                    className="btn btn-outline-light"
                    to={`/case-study/${project.caseStudyTitle.replace(/\s+/g, "-")}`}
                  >
                    <span className="btn_label" data-text="Explore">
                      Explore
                    </span>
                    <span className="btn_icon">
                      <i className="fa-solid fa-arrow-up-right"></i>
                    </span>
                  </Link>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className="container text-center d-block d-lg-none">
        <div className="btns_group pb-0">
          <Link
            onClick={ClickHandler}
            className="btn btn-primary"
            to="/case-study"
          >
            <span className="btn_label" data-text="All Works">
              All Case Studies
            </span>
            <span className="btn_icon">
              <i className="fa-solid fa-arrow-up-right"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CaseStudySection;
